import styles from './OverlapBanner.module.css';

import { overlapStore, useOverlapBannerVisible } from '~/stores/overlapStore';

export function OverlapBanner() {
  const isVisible = useOverlapBannerVisible();

  if (!isVisible) {
    return null;
  }

  const handleRefresh = (): void => {
    void overlapStore.getState().refreshWithPrime();
  };

  return (
    <div
      aria-live="polite"
      className={styles.banner}
      data-testid="overlap-banner"
      role="status"
    >
      <div className={styles.container}>
        <span className={styles.message}>
          Server has been updated. Refresh the page to update the client.
        </span>
        <button
          className={styles.refreshButton}
          data-testid="overlap-banner-refresh"
          onClick={handleRefresh}
          type="button"
        >
          Refresh
        </button>
      </div>
    </div>
  );
}
